import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { EaGridkyService } from '../ea-gridky.service';

export interface GrikeyCriteria {
  label: string;
  icon?: string;
  value: string;
}

@Component({
    selector: 'ea-gridky-criteria',
    templateUrl: './ea-gridky-criteria.component.html',
    styleUrls: ['./ea-gridky-criteria.component.scss'],
    standalone: false
})
export class EaGridkyCriteriaComponent implements OnInit {
  criteria: GrikeyCriteria[];

  constructor(public gridkyService: EaGridkyService) {}

  ngOnInit() {
    this.criteria = this.gridkyService.getCriterias();

    this.gridkyService.productChanged.subscribe(
      () => (this.criteria = this.gridkyService.getCriterias()),
    );
  }

  get product() {
    return this.gridkyService.product || undefined;
  }
}
